import { render, staticRenderFns } from "./OutageNotification.vue?vue&type=template&id=fb2ef2b4&scoped=true&"
import script from "./OutageNotification.vue?vue&type=script&lang=js&"
export * from "./OutageNotification.vue?vue&type=script&lang=js&"
import style0 from "./OutageNotification.vue?vue&type=style&index=0&id=fb2ef2b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2ef2b4",
  null
  
)

export default component.exports